import { localePath, useLocale, useMessages } from "../i18n";
import { ARTICLES_PATH, FAQ_PATH } from "../shared";

/**
 * The not-found page, with no router in it.
 *
 * It is rendered twice: by the routed `NotFoundPage` when the app reaches a
 * path it has no route for, and into `dist/404.html` at build time, which is
 * what a static host serves for a URL that matches no file at all.
 *
 * The second one is the reason this exists. Without a 404 document, a host
 * answers every unknown URL with the homepage at status 200, so a crawler
 * collects an unbounded set of distinct addresses all serving the same page.
 *
 * There is one 404 document for the whole site, so it is written in English:
 * a request that matched no file also matched no language, and the browser
 * picks the language up again as soon as the bundle wakes and re-renders.
 */
export function NotFoundView() {
  const locale = useLocale();
  const t = useMessages();

  return (
    <main className="status">
      <p className="tag">404</p>
      <h1>{t.notFound.title}</h1>
      <p>{t.notFound.body}</p>
      <a className="btn btn--primary btn--lg" href={localePath(locale, "/")}>
        <span>{t.notFound.cta}</span>
      </a>
      <p className="status__aside">
        {t.notFound.asideBefore}{" "}
        <a href={localePath(locale, ARTICLES_PATH)}>{t.notFound.asideGuides}</a>{" "}
        {t.notFound.asideAnd}{" "}
        <a href={localePath(locale, FAQ_PATH)}>{t.notFound.asideQuestions}</a>{" "}
        {t.notFound.asideAfter}
      </p>
    </main>
  );
}
